import { API_ROOT } from '@/config'
import Vue from 'vue'

const contextPath = 'item-batch'

export default (<any>Vue).resource(API_ROOT + contextPath + '{/id}', {})
